import {Text} from '@mantine/core';
import {css} from 'aphrodite';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

import {sharedStyles} from './McpModalStyles';

interface McpAuthPromptProps {
  authRedirectUrl: string;
  onAuthComplete: () => void;
}

export default function McpAuthPrompt(props: McpAuthPromptProps): JSX.Element {
  const {authRedirectUrl, onAuthComplete} = props;

  const handleAuthClick = (): void => {
    const authWindow = window.open(authRedirectUrl, '_blank');

    // Poll to check if the window is closed, then notify parent
    if (authWindow) {
      const pollInterval = setInterval(() => {
        if (authWindow.closed) {
          clearInterval(pollInterval);
          onAuthComplete();
        }
      }, 500);
    }
  };

  return (
    <div className={css(sharedStyles.loadingState)}>
      <Text>Authentication required.</Text>
      <Button
        type="button"
        buttonStyle={ButtonStyle.PRIMARY}
        size={ButtonSize.SMALL}
        text="Authenticate"
        onClick={handleAuthClick}
      />
    </div>
  );
}
